import { CAT_DISPLAY } from './cats';
import { formatTime } from './format';
import type { HudStore } from './store';

export function Results({ store }: { store: HudStore }) {
  const snap = store.snapshot.value;
  if (!snap || snap.phase !== 'finished' || !snap.results?.length) return null;
  const rows = [...snap.results].sort((a, b) => (a.dsq === b.dsq ? a.place - b.place : a.dsq ? 1 : -1));
  // A compact panel at the side: the cats on the 3D podium in the middle of the picture are the show.
  return (
    <section class="panel results" aria-labelledby="results-title">
      <h2 id="results-title">Official results · Race {snap.raceNo}</h2>
      <table>
        <thead><tr><th scope="col">Place</th><th scope="col">Cat</th><th scope="col">Time</th></tr></thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id} class={r.dsq ? 'dsq' : ''}>
              <td>{r.dsq ? '—' : r.place}</td>
              <th scope="row"><span class="swatch" style={{ background: CAT_DISPLAY[r.id].colour }} aria-hidden="true" />{CAT_DISPLAY[r.id].name}{!r.dsq && r.place === 1 && <span class="crown" aria-label="winner"> 👑</span>}</th>
              <td class="num">{r.dsq ? <span class="stamp">DSQ · doping control</span> : formatTime(r.seconds)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <p class="next">Next race follows automatically.</p>
    </section>
  );
}
